<template>  
  <TestsList :editable="true" />
</template>

<script>
import TestsList from '../../Shared/TestsList/index.vue';

export default {
  name: 'tasks',
  components: { TestsList }
}
</script>
